import React from 'react';
import classes from './GridView.module.css';
import orderProductIcon from '../../../assets/icons/order-product.png';
import plusIcon from '../../../assets/icons/plusIconRound.svg';
import { getTextByLanguage } from '../../../utils/miscUtils';

type Props = {
  product: any;
  handleClick: any;
  addProductClick: (event: React.MouseEvent<HTMLImageElement, MouseEvent>, product: any) => void;
};

export const GridView: React.FC<Props> = ({ product, handleClick, addProductClick }) => {
  const handleAddProductClick = (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
    event.stopPropagation();
    addProductClick(event, product);
  };
  const lang = localStorage.getItem('lang') || 'en';
  return (
    <div className={classes.productItem} onClick={handleClick}>
      <div className={classes.imageWrapper}>
        <img
          alt={'product icon'}
          src={
            product.images && product.images.length > 0 ? product.images[0].url : orderProductIcon
          }
          className={classes.productIcon}
        />
        <img
          alt={'plus icon'}
          src={plusIcon}
          className={classes.plusIcon}
          onClick={handleAddProductClick}
        />
      </div>
      <div className={classes.productName}>
        {getTextByLanguage(product.name, lang)}
      </div>
      <div className={classes.productPrice}>
        {product.price ? `€ ${(product.price / 100).toFixed(2)}` : '€ 0.00'}
      </div>
    </div>
  );
};
